import ProductionPlantForm from './ProductionPlantForm';

export default ProductionPlantForm;
